import { forwardRef } from 'react';

import { MuiIconProps } from './types';

const MuiIcon = forwardRef<SVGSVGElement, MuiIconProps>(
  ({ icon: Icon, width = 20, height, color, sx, ...other }, ref) => (
    <Icon
      ref={ref}
      sx={{
        width,
        height: height ?? width,
        ...(color ? { color } : {}),
        ...sx,
      }}
      {...other}
    />
  )
);

export default MuiIcon;
